<mat-card class="large-card">
    <div class="settingsBody">
        <div class="settings-heading">General Ledger Mapping</div>
        <div style="display: flex; justify-content: space-between">
            <div style="display: flex">
                <mat-form-field fluid appearance="outline" class="example-full-width">
                    <mat-label>Find General Ledger</mat-label>
                    <input
                        matInput
                        [(ngModel)]="glAcctSearchTerm"
                        class="search-field"
                        #productSearchBox
                        (ngModelChange)="filterAccts()"
                        [ngModelOptions]="{ standalone: true }"
                    />
                    <mat-icon matSuffix>search</mat-icon>
                </mat-form-field>
                <div class="mapping-export-button-area">
                    <span
                        (click)="exportToExcel(kendoGrid)"
                        title="Download Excel"
                        class="mapping-export-button"
                    >
                        <mat-icon fontSet="fas" fontIcon="fa-file-excel"></mat-icon>
                    </span>
                </div>
            </div>

            <button id="saveNewAccount" *ngIf="addNew" type="button" mat-raised-button>SAVE</button>
            <button
                id="cancelNewAccount"
                *ngIf="addNew"
                type="button"
                mat-raised-button
                (click)="cancelNewAccount()"
            >
                CANCEL
            </button>
            <button id="addNewButton" type="button" mat-raised-button (click)="addNewAccount()">
                <i id="innerAddNewButton" class="fal fa-plus-square" A></i>
                &nbsp; ADD NEW ACCOUNT
            </button>
        </div>

        <div>
            <kendo-grid
                id="kendoGrid"
                #kendoGrid="kendoGrid"
                [data]="glAccts"
                [height]="695"
                [pageSize]="pageSize"
                [skip]="skip"
                [pageable]="true"
                [sort]="glAcctSort"
                [sortable]="{
                    mode: 'single',
                    allowUnsort: true
                }"
                (sortChange)="sortChange($event)"
                [scrollable]="true"
                [loading]="loading"
                (pageChange)="pageChange($event)"
                (cellClick)="cellClickHandler($event)"
                class="lg-kendo-grid"
            >
                <ng-template kendoGridNoRecordsTemplate>
                    <div class="no-data-message-area" *ngIf="noAccts">
                        <no-data-screen [noDataType]="noDataType"> </no-data-screen>
                    </div>
                </ng-template>

                <kendo-grid-column field="accountNumber" title="ACCOUNT NUMBER"></kendo-grid-column>
                <kendo-grid-column field="accountName" title="ACCOUNT NAME">
                    <ng-template kendoGridCellTemplate let-item>
                        <input class="freeform-text" [(ngModel)]="item.accountName" type="text" />
                    </ng-template>
                </kendo-grid-column>
                <kendo-grid-column field="accountType" title="ACCOUNT TYPE">
                    <ng-template
                        kendoGridEditTemplate
                        let-dataItem="dataItem"
                        let-column="column"
                        let-formGroup="formGroup"
                    >
                        <kendo-dropdownlist
                            [defaultItem]="{ typeKey: null, type: null }"
                            [data]="accountTypes"
                            textField="type"
                            valueField="type"
                            [valuePrimitive]="true"
                            [formControl]="formGroup.get('accountType')"
                        >
                        </kendo-dropdownlist>
                    </ng-template>
                </kendo-grid-column>
                <kendo-grid-column field="accountCategory" title="ACCOUNT CATEGORY">
                    <ng-template kendoGridCellTemplate let-item>
                        <input
                            #category
                            class="freeform-text"
                            [(ngModel)]="item.accountCategory"
                            type="text"
                            matInput
                            [matAutocomplete]="auto"
                            (keyup)="reqNameChanged(category.value)"
                        />
                        <mat-autocomplete autoActiveFirstOption #auto="matAutocomplete">
                            <mat-option
                                *ngFor="let suggestion of filteredSuggestions | async"
                                [value]="suggestion"
                            >
                                {{ suggestion }}
                            </mat-option>
                        </mat-autocomplete>
                    </ng-template>
                </kendo-grid-column>
                <kendo-grid-column field="isLoanAccount" title="Loan Account">
                    <ng-template
                        kendoGridEditTemplate
                        let-dataItem="dataItem"
                        let-column="column"
                        let-formGroup="formGroup"
                    >
                    </ng-template>
                    <ng-template kendoGridCellTemplate let-item>
                        <input
                            type="checkbox"
                            id="loanAccountCheckbox"
                            [checked]="item.isLoanAccount"
                            [disabled]="item.isLoanAccount === null"
                            [(ngModel)]="item.isLoanAccount"
                            kendoCheckBox
                        />
                    </ng-template>
                </kendo-grid-column>

                <kendo-grid-excel [fileName]="exportFileName" [fetchData]="getExcelExportData">
                    <kendo-excelexport-column field="accountNumber" title="ACCOUNT NUMBER">
                    </kendo-excelexport-column>
                    <kendo-excelexport-column field="accountName" title="ACCOUNT NAME">
                    </kendo-excelexport-column>
                    <kendo-excelexport-column field="accountType" title="ACCOUNT TYPE">
                    </kendo-excelexport-column>
                    <kendo-excelexport-column field="accountCategory" title="ACCOUNT CATEGORY">
                    </kendo-excelexport-column>
                    <kendo-excelexport-column field="isLoanAccount" title="LOAN ACCOUNT">
                    </kendo-excelexport-column>
                </kendo-grid-excel>

                <ng-template kendoPagerTemplate>
                    <kendo-pager-prev-buttons class="text-color-black"></kendo-pager-prev-buttons>
                    <kendo-pager-input class="text-color-black"></kendo-pager-input>
                    <kendo-pager-info class="text-color-black"></kendo-pager-info>
                    <kendo-pager-next-buttons class="text-color-black"></kendo-pager-next-buttons>
                    <kendo-pager-page-sizes
                        class="text-color-black"
                        [pageSizes]="[10, 25, 50, 100]"
                    ></kendo-pager-page-sizes>
                </ng-template>
            </kendo-grid>
        </div>
        <div style="text-align: right">
            <button
                mat-raised-button
                class="button"
                (click)="submitChanges()"
                style="margin-top: 10px"
            >
                SAVE CHANGES
            </button>
        </div>
    </div>
</mat-card>
